import { UserRole } from '@/types/enums';
import api from './client/axios';

export interface UserFilters {
  role: UserRole;
}

export const getUsers = async (filters?: UserFilters) => {
  const params = new URLSearchParams();

  filters &&
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });

  const response = await api.get(`/users?${params.toString()}`);
  return response.data.users;
};
